var m = require('mithril');
var Masonry = require('masonry-layout');

var masonry = function(vnode) {
  vnode.state.msnry = new Masonry(vnode.dom, {
    // options
    itemSelector: '.grid-item',
    percentagePosition:true,
  });
};

module.exports = masonry;